<style lang="less" rel="stylesheet/less" scoped>
    .row{
        margin:0 20px;
    }
</style>
<template>
    <div>
        <form class="form" @submit.prevent="submit();" >
            <div class="row">
                <my-input class="the-input" ref="username" v-model="form.username" wide required no-required-sign blur-check placeholder="用户名"></my-input>
            </div>
            <div class="row">
                <my-input class="the-input" ref="phone" type="number" v-model="form.phone" wide required no-required-sign blur-check placeholder="手机号"></my-input>
            </div>
            <div class="row">
                <my-input class="the-input" ref="password" type="password" wide v-model="form.password" required no-required-sign blur-check placeholder="密码"></my-input>
            </div>
            <div class="row" style="margin-top:20px;">
                <button class="btn wide" @click="submit();">提交{{ loading ? '...' : ''}}</button>
            </div>
        </form>
    </div>
</template>
<script type="text/ecmascript-6">

    import UserService from '../lib/UserService';
    import event from '../lib/event';
    import util from '../lib/util';
    import config from '../lib/config';
    import preload from '../lib/preload';

    export default {
        data() {
            return {
                loading:false,
                form:{
                    username:'',
                    phone:'',
                    password:'',
                }
            }
        },
        computed: {},
        methods: {
            checkValid:function () {
                var isValid = true;
                $.each(this.$refs,function (k,v) {
                    if(v.checkValid && !v.checkValid()){
                        isValid = false;
                    }
                })
                return isValid;
            },
            submit(){
                var vm = this;
                if(vm.loading)return;
                if(this.checkValid()){
                    vm.loading = true;
                    UserService.registerWithPhone(this.form.username,this.form.phone,this.form.password).then((res)=>{
                        vm.loading = false;
                        event.emit('toast','注册成功');
                        $router.go({name:'login'});
                    }).catch(err=>{
                        vm.loading = false;
                    })
                }
            }
        },
        components: {myInput:require('../components/form/Input.vue')},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// register.vue?9d2ce69e